import { api } from '@/helpers/apiClient'
import logger, { toErrorMessage } from '@/helpers/logger'
import { userListDtoSchema, type UserListDto } from '@lib/dto/user.dto'
import type { IUserService } from '@/types/UserService.types'

/**
 * Service for the user REST endpoints — the roster of people with access.
 * Responses are validated against the shared `@lib` schema at the boundary.
 */
class UserService implements IUserService {
  async list(): Promise<UserListDto> {
    try {
      return await api.get('/users', userListDtoSchema)
    } catch (error) {
      logger.error('Failed to list users', { error: toErrorMessage(error) })
      throw error
    }
  }
}

export const userService = new UserService()
